
export const GDPR_STORAGE_KEY = 'AcceptedTermsVersion';
export const GDPR_CURRENT_VERSION = 2.0;
